import React from "react";
import { Alert as Alert$1, Box } from "@mui/material";
import { makeStyles } from "tss-react/mui";
import { LocalizedText } from "../i18n/LocalizedText.js";
import { IconColor, Icon } from "../icons/Icon.js";
import { CustomIcon } from "../icons/types.js";
import "../icons/ExpandMoreIcon.js";
import { SystemColorsEnum } from "../../style/types.js";
import "../../style/hooks.js";
const useClasses = makeStyles()((theme, _params, classes) => ({
  alert: {
    position: "relative",
    borderRadius: theme.custom.defaultBorderRadius * 1.5,
    overflow: "hidden",
    fontSize: theme.typography.body1.fontSize
  },
  alertContent: {
    position: "absolute",
    top: 0,
    right: 0,
    bottom: 0,
    left: theme.spacing(0.375),
    paddingLeft: theme.spacing(2),
    display: "flex",
    alignItems: "center"
  },
  alertText: {
    display: "flex",
    gap: theme.spacing(1)
  },
  alertTitle: {
    fontWeight: theme.typography.h6.fontWeight
  },
  alertIcon: {
    fontSize: theme.typography.body1.fontSize,
    marginRight: theme.spacing(1.5)
  },
  alertGrey: {
    color: theme.palette.secondary.main,
    background: theme.palette.secondary.main,
    [`& .${classes.alertContent}`]: {
      background: theme.custom.palette.content.backgroundLight
    }
  },
  alertGreen: {
    color: theme.palette.success.main,
    background: theme.palette.success.main,
    [`& .${classes.alertContent}`]: {
      background: theme.palette.success.light
    }
  },
  alertBronze: {
    color: theme.custom.palette.status.bronze.main,
    background: theme.custom.palette.status.bronze.main,
    [`& .${classes.alertContent}`]: {
      background: theme.custom.palette.status.bronze.light
    }
  },
  alertBlue: {
    color: theme.custom.palette.status.navyBlue.main,
    background: theme.custom.palette.status.navyBlue.main,
    [`& .${classes.alertContent}`]: {
      background: theme.custom.palette.status.navyBlue.light
    }
  }
}));
const Alert = ({ title, description, color, icon }) => {
  const { classes, cx } = useClasses();
  const iconColorMap = {
    bronze: IconColor.Bronze,
    green: IconColor.Success,
    grey: IconColor.Secondary,
    blue: SystemColorsEnum.NavyBlue
  };
  return /* @__PURE__ */ React.createElement(
    Alert$1,
    {
      className: cx(classes.alert, {
        [classes.alertBronze]: color === "bronze",
        [classes.alertGreen]: color === "green",
        [classes.alertGrey]: color === "grey",
        [classes.alertBlue]: color === "blue"
      })
    },
    /* @__PURE__ */ React.createElement(Box, { className: classes.alertContent }, /* @__PURE__ */ React.createElement(Icon, { color: iconColorMap[color], icon, className: classes.alertIcon }), /* @__PURE__ */ React.createElement("span", { className: classes.alertText }, /* @__PURE__ */ React.createElement("span", { className: classes.alertTitle }, /* @__PURE__ */ React.createElement(LocalizedText, { label: title })), /* @__PURE__ */ React.createElement(LocalizedText, { label: description })))
  );
};
function InfoAlert({ title, description, color = "grey" }) {
  return /* @__PURE__ */ React.createElement(Alert, { title, description, icon: CustomIcon.ErrorCircleOutline, color });
}
function SuccessAlert({ title, description }) {
  return /* @__PURE__ */ React.createElement(Alert, { title, description, icon: CustomIcon.ConfirmCircle, color: "green" });
}
function ErrorAlert({ title, description }) {
  return /* @__PURE__ */ React.createElement(Alert, { title, description, icon: CustomIcon.ErrorCircleOutline, color: "bronze" });
}
export {
  ErrorAlert,
  InfoAlert,
  SuccessAlert
};
//# sourceMappingURL=InfoAlert.js.map
